<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_1"></a><a id="part01"></a>PART 1</h2>
<h2 class="h2a">London</h2>
<p class="linespace"> </p>
<p class="para1">Animate London, with smarting eyes and irritated lungs, was blinking, wheezing, and choking; inanimate London was a sooty spectre, divided in purpose between being visible and invisible, and so being wholly neither.</p>
<p class="right-para1">—Charles Dickens</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?555f1cdd